<ng-container [ngTemplateOutlet]="shouldRenderPreviousNoCheckIn() ? noReflection : previousCheckIn" [ngTemplateOutletContext]="{ type: 'previous' }"> </ng-container>

<ng-container [ngTemplateOutlet]="shouldRenderCurrentNoCheckIn() ? noReflection : currentCheckIn" [ngTemplateOutletContext]="{ type: 'current' }"> </ng-container>

<ng-template #previousCheckIn>
  <ng-container *ngIf="!filter || filter === 'published'">
    <cadence-label [cadenceStartDate]="prevCadenceStartDate"></cadence-label>
    <!-- MOOD PREV -->
    <reflection-mood
      class="previous-check-in"
      *ngIf="shouldRenderMood(prevReflection)"
      [isEditModeEnabled]="prevReflection.isEditing"
      [reflectionMood]="prevReflection.mood"
      (moodChange)="onMoodChange($event, 'previous')"></reflection-mood>
    <i
      class="dot-container previous-check-in"
      *ngIf="!shouldRenderMood(prevReflection) && shouldRenderMood(currReflection) && !shouldRenderCurrentNoCheckIn()"
      ui-icon
      uiTheme="fill"
      uiType="dots"></i>

    <!-- QUESTIONS PREV -->
    <ng-container *ngFor="let question of prevQuestionsFormatted; let i = index">
      <reflection-question
        class="previous-check-in"
        *ngIf="shouldRenderQuestion(prevReflection, question)"
        [autofocus]="i === 0"
        [question]="question"
        [isEditModeEnabled]="prevReflection.isEditing"
        (answerUpdate)="onAnswerChange($event, 'previous')"></reflection-question>
      <i
        class="dot-container previous-check-in"
        *ngIf="!shouldRenderQuestion(prevReflection, question) && shouldRenderQuestion(currReflection, currQuestionsFormatted?.[i]) && !shouldRenderCurrentNoCheckIn()"
        ui-icon
        uiTheme="fill"
        uiType="dots"></i>
    </ng-container>
  </ng-container>

  <!-- NOTES PREV -->
  <ng-container *ngFor="let note of prevReflection?.notes | filterNotes : filter; let i = index">
    <reflection-note
      class="previous-check-in"
      *ngIf="shouldRenderNote(prevReflection, note)"
      [note]="note"
      [isEditModeEnabled]="prevReflection.isEditing && !filter"
      (noteChange)="onNoteChange($event, 'previous', i)"></reflection-note>
    <i
      class="dot-container previous-check-in"
      *ngIf="!shouldRenderNote(prevReflection, note) && shouldRenderNote(currReflection, currReflection.notes?.[i]) && !shouldRenderCurrentNoCheckIn()"
      ui-icon
      uiTheme="fill"
      uiType="dots"></i>
  </ng-container>

  <!-- DOTS WHEN FILTERING -->
  <div class="previous-check-in" *ngIf="filter && !(prevReflection?.notes | filterNotes : filter)?.length">
    <i class="dot-container" ui-icon uiTheme="fill" uiType="dots"></i>
  </div>

  <!--ACTIONS-->
  <checkin-action-buttons
    class="sp-mt-8"
    *ngIf="!filter && prevReflection.isEditable && prevReflection.isCurrentUser"
    [ngStyle]="{ 'grid-column-start': '1' }"
    [checkIn]="prevReflection"
    [isCheckInEmpty]="isReflectionEmpty(prevReflection)"
    (checkInPublish)="onPublishReflection($event)"
    (checkInEdit)="onEditReflection($event)"
    (checkInCancel)="onCancelReflection($event)"
    type="previous"></checkin-action-buttons>
</ng-template>

<ng-template #currentCheckIn>
  <ng-container *ngIf="!filter || filter === 'published'">
    <cadence-label class="current-check-in" [cadenceStartDate]="currCadenceStartDate"></cadence-label>
    <!-- MOOD CURR -->
    <reflection-mood
      class="current-check-in"
      *ngIf="shouldRenderMood(currReflection)"
      [isEditModeEnabled]="currReflection.isEditing"
      [reflectionMood]="currReflection.mood"
      (moodChange)="onMoodChange($event, 'current')"></reflection-mood>
    <i
      class="dot-container current-check-in"
      *ngIf="!shouldRenderMood(currReflection) && shouldRenderMood(prevReflection) && !shouldRenderPreviousNoCheckIn()"
      ui-icon
      uiTheme="fill"
      uiType="dots"></i>

    <!-- QUESTIONS CURR -->
    <ng-container *ngFor="let question of currQuestionsFormatted; let i = index">
      <reflection-question
        class="current-check-in"
        *ngIf="shouldRenderQuestion(currReflection, question)"
        [autofocus]="i === 0"
        [question]="question"
        [isEditModeEnabled]="currReflection.isEditing"
        (answerUpdate)="onAnswerChange($event, 'current')"></reflection-question>
      <i
        class="dot-container current-check-in"
        *ngIf="!shouldRenderQuestion(currReflection, question) && shouldRenderQuestion(prevReflection, prevQuestionsFormatted?.[i]) && !shouldRenderPreviousNoCheckIn()"
        ui-icon
        uiTheme="fill"
        uiType="dots"></i>
    </ng-container>
  </ng-container>

  <!-- NOTES CURR -->
  <ng-container *ngFor="let note of currReflection.notes | filterNotes : filter; let i = index">
    <reflection-note
      class="current-check-in"
      *ngIf="shouldRenderNote(currReflection, note)"
      [note]="note"
      [isEditModeEnabled]="currReflection.isEditing && !filter"
      (noteChange)="onNoteChange($event, 'current', i)"></reflection-note>
    <i
      class="dot-container current-check-in"
      *ngIf="!shouldRenderNote(currReflection, note) && shouldRenderNote(prevReflection, prevReflection.notes?.[i]) && !shouldRenderPreviousNoCheckIn()"
      ui-icon
      uiTheme="fill"
      uiType="dots"></i>
  </ng-container>

  <!--DOTS WHEN FILTERING FILTERING-->
  <div class="current-check-in" *ngIf="filter && !(currReflection.notes | filterNotes : filter).length">
    <i class="dot-container" ui-icon uiTheme="fill" uiType="dots"></i>
  </div>

  <!--ACTIONS-->

  <checkin-action-buttons
    class="sp-mt-8"
    *ngIf="!filter && currReflection.isEditable && currReflection.isCurrentUser"
    [ngStyle]="{ 'grid-column-start': '2' }"
    [checkIn]="currReflection"
    [isCheckInEmpty]="isReflectionEmpty(currReflection)"
    (checkInPublish)="onPublishReflection($event)"
    (checkInEdit)="onEditReflection($event)"
    (checkInCancel)="onCancelReflection($event)"
    type="current"></checkin-action-buttons>
</ng-template>

<ng-template #noReflection let-type="type">
  <cadence-label *ngIf="!filter" [ngStyle]="{ 'grid-column-start': type === 'current' ? 2 : 1 }" [cadenceStartDate]="type === 'current' ? currCadenceStartDate : prevCadenceStartDate"></cadence-label>
  <div class="no-reflection" [ngStyle]="{ 'grid-column-start': type === 'current' ? 2 : 1 }">
    <span>{{ "check_ins_no_check_in" | localize }}</span>
    <button
      class="sp-mt-16"
      *ngIf="((type === 'current' && currReflection?.isCurrentUser && currReflection?.isEditable) || (type === 'previous' && prevReflection?.isCurrentUser && prevReflection?.isEditable)) && !filter"
      (click)="onFillOutReflection(type)"
      ui-button
      uiShape="round"
      uiType="default"
      uiSize="large">
      {{ "reflections_fill_out" | localize }}
    </button>
  </div>
</ng-template>
